module.exports = __webpack_public_path__ + "static/media/hungrybirds.790d895e.png";